import { StammdatenRoot } from "./types";

/**
 * Wenn Stammdaten automatisch erstellt wurden (e. g. Stammdatenmapping) ist das dokument nur bearbeitbar, wenn editing allowed true ist. Ansonsten ist es immer bearbeitbar.
 * @param stammdatenRoot Stammdatendokument, das verarbeitet werden soll.
 */
export function isStammdatenDocumentEditable(stammdatenRoot: StammdatenRoot): boolean {
	const stammdatenMetadata = stammdatenRoot?.stammdatenDefault?.stammdatenMetadata;
	return (
		!stammdatenMetadata ||
		!stammdatenMetadata.isAutomaticallyCreated ||
		(stammdatenMetadata.isAutomaticallyCreated && !!stammdatenMetadata.isEditingAllowed)
	);
}
